import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const SocialIcons = (props, context) => {
  const { theme: { colorPrimary } } = context;
  
  return (
    <div className="social-icons animate-icons">
        <a rel="noopener noreferrer" href="mailto:jeongseok.son@gmail.com" style={ { color: colorPrimary } }><i className="fas fa-envelope"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/jeongseok" style={ { color: colorPrimary } }><i className="fab fa-linkedin"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/jeongseokson" style={ { color: colorPrimary } }><i className="fab fa-github"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/jeongseok_s" style={ { color: colorPrimary } }><i className="fab fa-twitter"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://scholar.google.com/citations?user=pIPaS_EAAAAJ&hl=en" style={ { color: colorPrimary } }><i className="fab ai ai-google-scholar"></i></a>
      </div>
  );
};

SocialIcons.contextTypes = {
  theme: PropTypes.any
};

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/SocialIcons/SocialIcons.js